import { Util } from '@/modules/util'
import { Request } from '@/classes/Request.ts'

export interface TMyEnrollmentInvitation {
  invitationId: number
  token: string
  status: string
  studentName: string | null
  formGroupName: string | null
  expiresAt: string | null
  isExpired: boolean
  isHeld: boolean
  startedAt: string | null
  isCompleted: boolean
}

// GET /ajax/enrollment/my-invitations — open invitations for the logged-in family user.
export const myEnrollmentInvitations = async (): Promise<TMyEnrollmentInvitation[]> => {
  const response = await new Request().get('/ajax/enrollment/my-invitations')
  return Util.Obj.keysToCamel(response.data.items) as TMyEnrollmentInvitation[]
}
